export default function concat(args) {
    return [].concat.apply([], args);
}
//# sourceMappingURL=concat.js.map